import { useCallback, useEffect, useState } from 'react';

export const useIntercom = () => {
  const [intercomAvailable, setIntercomAvailable] = useState(false);
  
  // Verificar si Intercom está disponible
  useEffect(() => {
    const checkIntercom = () => {
      if (typeof window !== 'undefined' && window.Intercom) {
        setIntercomAvailable(true);
        return true;
      }
      return false;
    };
    
    // Verificar al inicio
    checkIntercom();
    
    // Verificar periódicamente
    const interval = setInterval(() => {
      if (checkIntercom()) {
        clearInterval(interval);
      }
    }, 1000);
    
    return () => clearInterval(interval);
  }, []);

  const showMessenger = useCallback(() => {
    console.log('Intentando mostrar messenger de Intercom...');
    if (typeof window !== 'undefined' && window.Intercom) {
      try {
        window.Intercom('show');
        console.log('Messenger mostrado correctamente');
      } catch (error) {
        console.error('Error al mostrar messenger:', error);
        // Intento alternativo
        try {
          window.Intercom('showMessages');
        } catch (innerError) {
          console.error('Error al intentar método alternativo:', innerError);
        }
      }
    } else {
      console.warn('Intercom no está inicializado todavía');
    }
  }, []);

  const hideMessenger = useCallback(() => {
    if (typeof window !== 'undefined' && window.Intercom) {
      try {
        window.Intercom('hide');
      } catch (error) {
        console.error('Error al ocultar messenger:', error);
      }
    }
  }, []);

  const showNewMessage = useCallback((message = '') => {
    console.log('Iniciando nueva conversación...');
    if (typeof window !== 'undefined' && window.Intercom) {
      try {
        if (message) {
          window.Intercom('showNewMessage', message);
        } else {
          window.Intercom('showNewMessage');
        }
        console.log('Nueva conversación iniciada');
      } catch (error) {
        console.error('Error al iniciar conversación:', error);
        // Intento alternativo
        try {
          window.Intercom('show');
        } catch (innerError) {
          console.error('Error al intentar método alternativo:', innerError);
        }
      }
    } else {
      console.warn('Intercom no está inicializado todavía');
    }
  }, []);

  const updateUser = useCallback((userData) => {
    if (typeof window !== 'undefined' && window.Intercom) {
      try {
        window.Intercom('update', userData);
        console.log('Usuario actualizado en Intercom');
      } catch (error) {
        console.error('Error al actualizar usuario:', error);
      }
    }
  }, []);

  const trackEvent = useCallback((eventName, metadata = {}) => {
    if (typeof window !== 'undefined' && window.Intercom) {
      try {
        window.Intercom('trackEvent', eventName, metadata);
        console.log(`Evento trackeado: ${eventName}`, metadata);
      } catch (error) {
        console.error('Error al trackear evento:', error);
      }
    }
  }, []);

  const getUnreadCount = useCallback(() => {
    if (typeof window !== 'undefined' && window.Intercom) {
      try {
        return window.Intercom('getUnreadCount');
      } catch (error) {
        console.error('Error al obtener mensajes no leídos:', error);
        return 0;
      }
    }
    return 0;
  }, []);

  const shutdown = useCallback(() => {
    if (typeof window !== 'undefined' && window.Intercom) {
      try {
        window.Intercom('shutdown');
        console.log('Intercom cerrado correctamente');
      } catch (error) {
        console.error('Error al cerrar Intercom:', error);
      }
    }
  }, []);

  return {
    showMessenger,
    hideMessenger,
    showNewMessage,
    updateUser,
    trackEvent,
    getUnreadCount,
    shutdown,
    intercomAvailable
  };
};